module.exports = __webpack_public_path__ + "img/R03_02.2d54a998.jpg";